export const SPARTAN_CARD_IMAGE_PRELOAD_OFFSET = '400px 0px';
